function FilepreviewDirective(fileSystem, platform, authService, $timeout, dataAPIService, $sce) {
    "ngInject";

    return {
        restrict: 'EA',
        require: 'ngModel',
        scope: {
            'ngModel': '=',
            'disableDownload': "=?",
            'allowDelete':'=?',
            'onDelete': '&'
        },
        templateUrl: '/app/filesystem/filePreview.directive.html',
        link: function ($scope, iElement, iAttrs, ngModelCtrl) {
                    $scope.file = null;
                    $scope.disableDownload = $scope.disableDownload || false;

                    $scope.allowDelete = $scope.allowDelete || false;

                    $scope.$watch("ngModel", function (newVal, oldVal) {
                        $scope.file = newVal;
                    });

                    $scope.getDownloadURL = function(inline) {
                        if ($scope.file) {
                            return $sce.trustAsResourceUrl("/filesystem/download/" + $scope.file.id + "/?download=" + (!inline));
                        }
                        else {
                            return "";
                        }
                    };

                    $scope.remove = function () {
                        if ($scope.onDelete)
                            $scope.onDelete({file:$scope.file});

                        ngModelCtrl.$setViewValue(null); // clear
                    }

                }
    };
}

export default FilepreviewDirective;
